<template>
  <main
    class="flex flex-col w-full text-2xl font-semibold bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 transition-colors duration-300"
    :style="{ fontFamily: `'Syne', sans-serif` }">
    <!-- Small Screen Navbar -->
    <nav
      class="sm:hidden w-full bg-[#E87055] dark:bg-white/10 backdrop-blur-md text-white flex justify-between items-center px-4 py-3 transition-colors duration-300">
      <div
        class="font-bold text-lg bg-white/20 dark:bg-white/50 backdrop-blur-md rounded-md px-3 shadow-lg transition-colors duration-300">
        <img class="w-60" src="../assets/logo-header.png" alt="Logo" />
      </div>
      <button class="text-white font-medium hover:text-gray-200">
        <logout class="w-8 h-8" />
      </button>
    </nav>

    <!-- Page Container -->
    <div class="max-w-[1600px] w-full mx-auto px-10 flex-1">
      <!-- Header -->
      <header class="h-20 flex items-center mt-3 gap-2">
        <h1 class="text-2xl font-bold tracking-wide">Dashboard</h1>
        <p class="text-base"></p>
      </header>

      <!-- Divider -->
      <hr class="w-full mb-6 border-t-2" />
    </div>

    <!-- Main Content Area -->
    <div class="w-full h-full">
      <!-- Add your page content here -->
    </div>

    <!-- Footer -->
    <footer
      class="mt-auto px-10 py-3 text-sm text-gray-400 dark:text-gray-500 flex justify-center transition-colors duration-300">
      <p>Version blah blah</p>
    </footer>
  </main>
</template>
